<template>
    <div class="main">
        <c-panel title="INTEGRAÇÃO COM O SED — Secretaria Digital do Estado de São Paulo" titleIcon="fas fa-cloud">
            <div style="background: #fff8e1; border-left: 4px solid #ffc107; padding: 12px 16px; margin-bottom: 20px; border-radius: 4px;">
                <i class="el-icon-info" style="color: #ffc107; font-size: 16px;"></i>
                <strong style="margin-left: 6px;">Status:</strong>
                <span v-if="credencialAtiva" style="color: #67c23a; font-weight: bold; margin-left: 6px;">Credencial ativa — integração disponível.</span>
                <span v-else style="color: #909399; margin-left: 6px;">Aguardando credencial técnica da SEDUC-SP. Recursos disponíveis após liberação do canal.</span>
                <el-button @click="verificarCredencial" size="mini" type="primary" plain style="float: right;">
                    <i class="el-icon-refresh"></i> Verificar credencial
                </el-button>
            </div>

            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="6" v-for="op in operacoes" :key="op.key">
                    <div class="op-card" @click="abrirOperacao(op)" :class="{ 'disabled': !credencialAtiva }">
                        <div class="op-icon">
                            <i :class="op.icone"></i>
                        </div>
                        <div class="op-titulo">{{ op.titulo }}</div>
                        <div class="op-descricao">{{ op.descricao }}</div>
                    </div>
                </el-col>
            </el-row>

            <c-panel title="ENTIDADES COM CÓDIGO SED CADASTRÁVEL" titleIcon="fas fa-tags" style="margin-top: 30px;">
                <p style="color: #909399; margin-bottom: 10px;">
                    As entidades abaixo aceitam um <strong>código SED opcional</strong> para mapeamento bidirecional quando a integração for ativada:
                </p>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="8" v-for="ent in entidadesComCodigo" :key="ent">
                        <div style="padding: 8px 12px; background: #f5f7fa; border-radius: 4px; margin-bottom: 6px;">
                            <i class="el-icon-document"></i> {{ ent }}
                        </div>
                    </el-col>
                </el-row>
            </c-panel>

            <el-dialog :title="modalTitulo" :visible.sync="modalVisivel" width="500px">
                <div style="padding: 10px 0;">
                    <i class="el-icon-warning-outline" style="color: #e6a23c; font-size: 32px; float: left; margin-right: 12px;"></i>
                    <p style="margin: 0;">{{ modalMensagem }}</p>
                </div>
                <span slot="footer">
                    <el-button @click="modalVisivel = false">Fechar</el-button>
                </span>
            </el-dialog>
        </c-panel>
    </div>
</template>

<script>
export default {
    data: () => ({
        credencialAtiva: false,
        modalVisivel: false,
        modalTitulo: '',
        modalMensagem: '',
        operacoes: [
            { key: 'imp-turmas',     titulo: 'Importar turmas',                icone: 'fas fa-cloud-download-alt', cor: '#409eff', descricao: 'Sincronizar turmas do SED para o SMGE.' },
            { key: 'exp-turmas',     titulo: 'Exportar turmas',                icone: 'fas fa-cloud-upload-alt',   cor: '#67c23a', descricao: 'Enviar turmas do SMGE para o SED.' },
            { key: 'imp-alunos',     titulo: 'Importar cadastro de alunos',    icone: 'fas fa-user-graduate',      cor: '#909399', descricao: 'Sincronizar cadastro de alunos.' },
            { key: 'exp-mov',        titulo: 'Exportar movimentação de matrículas', icone: 'fas fa-exchange-alt', cor: '#e6a23c', descricao: 'Enviar movimentações para o SED.' },
        ],
        entidadesComCodigo: [
            'Períodos diários', 'Graus / Níveis de instrução', 'Séries / Cursos',
            'Salas', 'Turmas', 'Alunos', 'Servidores', 'Matrículas'
        ]
    }),
    mounted () { this.verificarCredencial() },
    methods: {
        verificarCredencial () {
            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/parametro-sistema/getValor/sed.integracao_habilitada`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                this.credencialAtiva = !!(r.data && r.data.valor)
            }).catch(() => { this.credencialAtiva = false })
        },
        abrirOperacao (op) {
            this.modalTitulo = op.titulo
            if (this.credencialAtiva) {
                this.modalMensagem = 'Operação prevista para liberação na próxima atualização — o canal técnico já está conectado e o endpoint backend será plugado na fase de implantação.'
            } else {
                this.modalMensagem = 'Aguardando credencial técnica da SEDUC-SP. ' +
                    'A funcionalidade será habilitada automaticamente após o município receber o Termo de Adesão e a chave de integração. ' +
                    'Para acelerar: abrir chamado junto à SEDUC-SP solicitando acesso à API do SED.'
            }
            this.modalVisivel = true
        }
    }
}
</script>

<style scoped>
.op-card {
    border: 1px solid #ebeef5;
    border-radius: 8px;
    padding: 24px 16px;
    text-align: center;
    cursor: pointer;
    background: #fff;
    transition: all .2s;
    height: 180px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.op-card:hover {
    box-shadow: 0 2px 12px rgba(0,0,0,.1);
    border-color: #409eff;
}
.op-card.disabled { opacity: .65; }
.op-icon {
    font-size: 36px;
    color: #409eff;
    margin-bottom: 12px;
}
.op-titulo {
    font-weight: bold;
    font-size: 14px;
    color: #303133;
    margin-bottom: 6px;
}
.op-descricao {
    font-size: 12px;
    color: #909399;
}
</style>
